(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["b2b-enquiry-form"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('b2b-enquiry-form')) {
    class B2BEnquiryForm extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('[data-b2b-form]');
        this.productsElement = this.querySelector('[data-b2b-products]');
        this.productTemplate = this.querySelector('[data-b2b-product-template]');
        this.searchInput = this.querySelector('[data-b2b-search]');
        this.searchResults = this.querySelector('[data-b2b-results]');
        this.searchWrap = this.querySelector('[data-b2b-search-wrap]');
        this.alert = this.querySelector('[data-b2b-alert]');
        this.submitButton = this.querySelector('[data-b2b-submit]');
        this.products = [];
        this.searchTimer = null;
        this.requestId = window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(16).slice(2)}`;

        this.searchInput.addEventListener('input', () => this.queueSearch());
        this.searchInput.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') this.closeSearch();
        });
        document.addEventListener('click', (event) => {
          if (!this.searchWrap.contains(event.target)) this.closeSearch();
        });
        this.form.addEventListener('submit', (event) => this.submit(event));
        this.loadSourceProduct();
      }

      async loadSourceProduct() {
        const params = new URL(window.location.href).searchParams;
        const handle = params.get('product_handle');
        const variantId = params.get('variant_id');
        if (!handle) return;

        this.productsElement.setAttribute('aria-busy', 'true');
        this.productsElement.textContent = this.dataset.loadingLabel;
        try {
          const product = await this.fetchProduct(handle, variantId);
          this.products = [{ ...product, isSource: true, quantityRange: '' }];
          this.renderProducts();
        } catch (error) {
          this.showError(this.dataset.errorLabel);
          this.productsElement.textContent = '';
        } finally {
          this.productsElement.removeAttribute('aria-busy');
        }
      }

      async fetchProduct(handle, variantId = '') {
        const base = this.dataset.productsUrl.endsWith('/') ? this.dataset.productsUrl : `${this.dataset.productsUrl}/`;
        const response = await fetch(`${base}${encodeURIComponent(handle)}.js`, { headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('Product could not be loaded');
        const product = await response.json();
        const variants = Array.isArray(product.variants) ? product.variants : [];
        const variant = variants.find((item) => String(item.id) === String(variantId)) || variants.find((item) => item.available) || variants[0] || {};
        const image = product.featured_image || product.images?.[0] || '';
        return {
          id: String(product.id || ''),
          gid: product.id ? `gid://shopify/Product/${product.id}` : '',
          handle: product.handle,
          title: product.title,
          url: new URL(product.url || `/products/${product.handle}`, window.location.origin).toString(),
          image: typeof image === 'string' ? image : image.src || '',
          variantId: String(variant.id || ''),
          variantTitle: variant.title && variant.title !== 'Default Title' ? variant.title : '',
          sku: variant.sku || ''
        };
      }

      renderProducts() {
        this.productsElement.textContent = '';
        this.products.forEach((product, index) => {
          const fragment = this.productTemplate.content.cloneNode(true);
          const row = fragment.querySelector('.b2b-product-row');
          const image = fragment.querySelector('[data-product-image]');
          const title = fragment.querySelector('[data-product-title]');
          const meta = fragment.querySelector('[data-product-meta]');
          const quantity = fragment.querySelector('[data-product-quantity]');
          const remove = fragment.querySelector('[data-product-remove]');

          row.dataset.productIndex = String(index);
          title.textContent = product.title;
          image.src = product.image || '';
          image.alt = product.title;
          image.hidden = !product.image;
          meta.textContent = [product.variantTitle, product.sku].filter(Boolean).join(' • ');
          quantity.name = `product_quantity_${index}`;
          quantity.value = product.quantityRange || '';
          quantity.addEventListener('change', () => {
            this.products[index].quantityRange = quantity.value;
          });

          if (!product.isSource) {
            remove.hidden = false;
            remove.textContent = this.dataset.removeLabel;
            remove.addEventListener('click', () => {
              this.products.splice(index, 1);
              this.renderProducts();
            });
          }

          this.productsElement.appendChild(fragment);
        });
      }

      queueSearch() {
        window.clearTimeout(this.searchTimer);
        const query = this.searchInput.value.trim();
        if (query.length < 2) {
          this.closeSearch();
          return;
        }
        this.searchTimer = window.setTimeout(() => this.search(query), 250);
      }

      async search(query) {
        if (this.products.length >= 4) {
          this.renderSearchMessage(this.dataset.limitLabel);
          return;
        }

        const endpoint = new URL(this.dataset.searchEndpoint, window.location.origin);
        endpoint.searchParams.set('q', query);
        endpoint.searchParams.set('resources[type]', 'product');
        endpoint.searchParams.set('resources[limit]', '8');
        endpoint.searchParams.set('resources[options][unavailable_products]', 'hide');
        this.searchInput.setAttribute('aria-busy', 'true');

        try {
          const response = await fetch(endpoint.toString(), { headers: { Accept: 'application/json' } });
          if (!response.ok) throw new Error('Search failed');
          const data = await response.json();
          const products = data.resources?.results?.products || [];
          this.renderSearchResults(products);
        } catch (error) {
          this.renderSearchMessage(this.dataset.errorLabel);
        } finally {
          this.searchInput.removeAttribute('aria-busy');
        }
      }

      renderSearchResults(products) {
        const selectedHandles = new Set(this.products.map((product) => product.handle));
        const available = products.filter((product) => !selectedHandles.has(product.handle));
        this.searchResults.textContent = '';

        if (!available.length) {
          this.renderSearchMessage(this.dataset.noResultsLabel);
          return;
        }

        available.forEach((product) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'b2b-search-result';
          button.setAttribute('role', 'option');

          const image = document.createElement('img');
          image.src = product.featured_image?.url || '';
          image.alt = '';
          image.width = 52;
          image.height = 52;
          image.hidden = !image.src;

          const title = document.createElement('span');
          title.textContent = product.title;
          const action = document.createElement('small');
          action.textContent = this.dataset.addLabel;

          button.append(image, title, action);
          button.addEventListener('click', async () => {
            if (this.products.length >= 4) {
              this.renderSearchMessage(this.dataset.limitLabel);
              return;
            }
            button.disabled = true;
            try {
              const loaded = await this.fetchProduct(product.handle);
              this.products.push({ ...loaded, isSource: false, quantityRange: '' });
              this.renderProducts();
              this.searchInput.value = '';
              this.closeSearch();
            } catch (error) {
              this.renderSearchMessage(this.dataset.errorLabel);
            }
          });
          this.searchResults.appendChild(button);
        });

        this.openSearch();
      }

      renderSearchMessage(message) {
        this.searchResults.textContent = '';
        const paragraph = document.createElement('p');
        paragraph.className = 'b2b-search-results__message';
        paragraph.textContent = message;
        this.searchResults.appendChild(paragraph);
        this.openSearch();
      }

      openSearch() {
        this.searchResults.hidden = false;
        this.searchInput.setAttribute('aria-expanded', 'true');
      }

      closeSearch() {
        this.searchResults.hidden = true;
        this.searchInput.setAttribute('aria-expanded', 'false');
      }

      showError(message) {
        this.alert.textContent = message;
        this.alert.hidden = false;
        this.alert.focus?.();
      }

      clearError() {
        this.alert.hidden = true;
        this.alert.textContent = '';
      }

      createPayload() {
        const formData = new FormData(this.form);
        return {
          requestId: this.requestId,
          customerName: String(formData.get('customer_name') || '').trim(),
          companyName: String(formData.get('company_name') || '').trim(),
          whatsappPhone: String(formData.get('whatsapp_phone') || '').trim(),
          email: String(formData.get('email') || '').trim(),
          city: String(formData.get('city') || '').trim(),
          customerTypes: formData.getAll('customer_type').map(String),
          customization: String(formData.get('customization') || ''),
          customizationDetails: String(formData.get('customization_details') || '').trim(),
          requiredBy: String(formData.get('required_by') || ''),
          additionalMessage: String(formData.get('additional_message') || '').trim(),
          website: String(formData.get('website') || ''),
          sourceUrl: this.products.find((product) => product.isSource)?.url || window.location.href,
          sourceProductGid: this.products.find((product) => product.isSource)?.gid || '',
          leadSource: 'Shopify bulk enquiry',
          products: this.products.map((product) => ({
            productId: product.gid,
            title: product.title,
            handle: product.handle,
            url: product.url,
            variantId: product.variantId ? `gid://shopify/ProductVariant/${product.variantId}` : '',
            variantTitle: product.variantTitle,
            sku: product.sku,
            quantityRange: product.quantityRange,
            isSource: product.isSource
          }))
        };
      }

      validatePayload(payload) {
        if (!this.form.checkValidity()) {
          this.form.reportValidity();
          return false;
        }
        if (!payload.products.length || payload.products.some((product) => !product.quantityRange)) return false;
        if (!payload.customerTypes.length) return false;
        return true;
      }

      buildWhatsAppMessage(payload, enquiryId) {
        const productLines = payload.products.map((product, index) => {
          const details = [product.sku, product.variantTitle].filter(Boolean).join(' / ');
          const suffix = details ? ` (${details})` : '';
          return `${index + 1}. ${product.title}${suffix} — ${product.quantityRange} pieces`;
        });
        const lines = [
          this.dataset.messageIntro,
          '',
          `${this.dataset.messageEnquiry}: ${enquiryId}`,
          '',
          `${this.dataset.messageProducts}:`,
          ...productLines,
          '',
          `${this.dataset.messageRequirement}: ${payload.customerTypes.join(', ')}`,
          `${this.dataset.messageCustomization}: ${payload.customization}${payload.customizationDetails ? ` — ${payload.customizationDetails}` : ''}`,
          `${this.dataset.messageRequiredBy}: ${payload.requiredBy || '-'}`,
          '',
          `${this.dataset.messageName}: ${payload.customerName}`,
          `${this.dataset.messageCompany}: ${payload.companyName || '-'}`,
          `${this.dataset.messageEmail}: ${payload.email || '-'}`,
          `${this.dataset.messageCity}: ${payload.city}`,
          `${this.dataset.messagePhone}: ${payload.whatsappPhone}`,
          '',
          `${this.dataset.messageNotes}: ${payload.additionalMessage || '-'}`
        ];
        return lines.join('\n');
      }

      async submit(event) {
        event.preventDefault();
        this.clearError();
        const payload = this.createPayload();
        if (!this.validatePayload(payload)) {
          this.showError(this.dataset.validationLabel);
          return;
        }

        this.submitButton.disabled = true;
        this.submitButton.textContent = this.dataset.submittingLabel;
        try {
          const response = await fetch(this.dataset.endpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(payload)
          });
          const result = await response.json().catch(() => ({}));
          if (!response.ok || !result.enquiryId) throw new Error(result.error || 'Submission failed');

          const number = this.dataset.whatsappNumber.replace(/\D/g, '');
          if (!number) throw new Error('WhatsApp number is not configured');
          const message = this.buildWhatsAppMessage(payload, result.enquiryId);
          window.location.assign(`https://wa.me/${number}?text=${encodeURIComponent(message)}`);
        } catch (error) {
          this.showError(this.dataset.errorLabel);
          this.submitButton.disabled = false;
          this.submitButton.textContent = this.dataset.submitLabel;
        }
      }
    }

    customElements.define('b2b-enquiry-form', B2BEnquiryForm);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
